import { useContext } from "react";
import invariant from "tiny-invariant";

import { ProductContext } from "./ProductProvider";

/**
 * Return product context.
 */
export function useProductContext() {
  const context = useContext(ProductContext);

  invariant(
    context,
    "No product context available. Ensure you wrapped ProductProvider.",
  );

  return context;
}

/**
 * Return product from context.
 */
export function useProduct() {
  return useProductContext().serverData;
}
